// extracted by mini-css-extract-plugin
export default {"container":"UpdatingAlert_container__pOThf","content":"UpdatingAlert_content__bu+fc","icon":"UpdatingAlert_icon__bqIim","jump":"UpdatingAlert_jump__Qs5pq"};